<template>
  <div class="page-detail">
    <div class="g-wrap">
      <el-breadcrumb class="g-breadcrumb" separator="/">
        <el-breadcrumb-item :to="`${$subsitePrefix}/innovation`"
          >创新创业</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ model.Headline }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="g-content" ref="mainContainer">
        <div v-if="loaded">
          <h3 class="title">{{ model.Headline }}</h3>
          <div class="attrs">
            <div class="info">
              <span class="time">发表时间：{{ model.PublishTime }}</span>
              <span class="source"
                >作者：{{ model.Author || model.Organization }}</span
              >
            </div>
            <div class="share" @click="share">
              <span size="mini">分享</span>
              <i class="el-icon-share"></i>
            </div>
          </div>
          <div class="content" v-html="model.Contents"></div>
          <div class="attach" v-if="model.File">
            <div class="attach-title">附件信息</div>
            <p>
              <i class="el-icon-link"></i>
              <a
                class="file"
                :href="`/files/${model.FileFilePath}`"
                :download="model.FileFileName"
                >{{ model.FileFileName }}</a
              >
              <a
                class="btn"
                :href="`/files/${model.FileFilePath}`"
                :download="model.FileFileName"
                >点击下载</a
              >
            </p>
          </div>
          <div class="relative">
            <div class="prev">
              上一篇：
              <span
                v-if="prev"
                @click="handleSwitch(prev)"
                class="link-text text-over"
              >
                {{ prev.Headline }}
              </span>
              <span v-else>没有了</span>
            </div>
            <div class="next">
              下一篇：
              <span
                v-if="next"
                @click="handleSwitch(next)"
                class="link-text text-over"
              >
                {{ next.Headline }}
              </span>
              <span v-else>没有了</span>
            </div>
          </div>
        </div>
        <div class="error-data" v-else></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCurrentAndAdjacent } from "api/app";
import { Loading } from "element-ui";
import { mapState } from "vuex";

// import Share from "_c/Common/Share.vue";
export default {
  components: {
    // Share
  },
  data() {
    return {
      shareUrl: window.location.href,
      model: {
        title: "",
        time: "",
        source: "",
        content: "",
        id: "1"
      },
      prev: null,
      next: null,
      id: null,
      name: "",
      loaded: false
    };
  },
  created() {
    this.init();
  },
  watch: {
    $route() {
      this.init();
    }
  },
  computed: {
    ...mapState("college", ["collegeData", "currentMajor"])
  },
  methods: {
    async loadData() {
      this.loaded = false;
      let loadingOptions = {
        target: this.$refs.mainContainer,
        fullscreen: false
      };
      let loadingInstance = Loading.service(loadingOptions);
      const res = await getCurrentAndAdjacent({
        name: this.name,
        id: this.id,
        college: this.collegeData.college.Id
      });
      if (res) {
        this.model = res.current;
        this.prev = res.prev;
        this.next = res.next;
        this.loaded = true;
      } else {
        this.$message.error("异常数据");
      }
      loadingInstance.close();
    },
    init() {
      this.name = this.$route.params.name;
      this.id = this.$route.query.id;
      this.loadData();
    },
    handleSwitch(item) {
      this.id = item.Id;
      this.loadData();
    },
    share() {
      window.localStorage.setItem("shareUrl", window.location.href);
      this.$router.push(this.$subsitePrefix + "/share-page");
    }
  }
};
</script>

<style lang="scss" scoped>
.page-detail {
  background: #f6f6f9;
  padding-bottom: 40px;
  .title {
    font-size: 32px;
    color: #333333;
    font-weight: 500;
    padding: 0 0 15px 0;
    line-height: 1.4em;
  }
  .attrs {
    font-size: 16px;
    color: #999999;
    line-height: 18px;
    padding-bottom: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .info {
      .time {
        padding-right: 30px;
      }
    }
  }
  .content {
    font-size: 18px;
    color: rgba(51, 51, 51, 1);
    line-height: 1.8em;
    ::v-deep p {
      text-indent: 2em;
      padding-bottom: 1em;
    }
  }
  .relative {
    display: flex;
    justify-content: space-between;
    padding: 16px 0 40px 0;
    border-top: 1px solid #eee;
    margin-top: 40px;
    font-size: 16px;
    color: #999999;
    .link-text {
      max-width: 500px;
      cursor: pointer;
      &:hover {
        color: $primary-color;
      }
    }
    .prev {
      display: flex;
      flex: 1;
    }
    .next {
      display: flex;
      flex: 1;
      justify-content: flex-end;
    }
  }
}
.share {
  cursor: pointer;
  padding: 2px 4px;
  border-radius: 4px;
  &:hover {
    background: $primary-color;
    color: #ffffff;
  }
}
</style>
